const markLessonComplete = () => {
    document.addEventListener('DOMContentLoaded', () => {
        const nextLink = document.querySelector('.ld-navigation__next-link');
        if (!nextLink) return;
        const nextWrapper = nextLink.closest('.ld-navigation__next');
        if (!nextWrapper) return;

        nextLink.addEventListener('click', (e) => {
            e.preventDefault();

            nextLink.classList.add('ld-next-loading');
            nextLink.style.pointerEvents = 'none';
            const labelLong = nextLink.querySelector('.ld-navigation__label--long');
            const originalText = labelLong ? labelLong.textContent : '';

            const lessonId = nextLink.dataset.id;
            const courseId = nextLink.dataset.courseId;
            const nonce = nextLink.dataset.nonce;
            const ajaxUrl = rcData.ajaxUrl;
            const nextUrl = nextLink.href;

            const data = new URLSearchParams({
                action: 'ld_mark_lesson_complete',
                lesson_id: lessonId,
                course_id: courseId,
                next_url: nextUrl,
                nonce: nonce
            });

            fetch(ajaxUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: data.toString()
            })
                .then(res => res.json())
                .then(json => {
                    if (json && json.success) {
                        window.location.href = json.next_url || nextUrl;
                    } else {
                        const msg = (json && json.data && json.data.message)
                            ? json.data.message
                            : 'Помилка при завершенні уроку. Спробуйте ще раз.';
                        alert(msg);
                        resetLink();
                    }
                })
                .catch(err => {
                    console.error(err);
                    alert('Помилка з’єднання з сервером.');
                    resetLink();
                });

            function resetLink() {
                nextLink.style.pointerEvents = '';
                if (labelLong) labelLong.textContent = originalText;
                nextLink.classList.remove('ld-next-loading');
            }
        });
    });

};

export default markLessonComplete;
